import { useMap } from '@/hooks/useMap';
import React, { useEffect, useRef } from 'react';
import AMapLoader from '@amap/amap-jsapi-loader';

interface AMapViewProps {
  data?: Array<{ lat: string | number; lon: string | number; name: string; status: string }>;
}

const AMapView: React.FC<AMapViewProps> = ({ data = [] }) => {
  const { isInitialled, mapKey } = useMap();
  const AMapRef = useRef(null);
  const mapRef = useRef(null);
  const mapIdRef = useRef(`amap-${Date.now()}-${Math.random()}`);

  const showMass = (list: { lat: string | number; lon: string | number; name: string; status: string }[]) => {
    const AMap = AMapRef.current;
    // @ts-ignore
    if (!AMap || !mapRef.current) return;
    
    // @ts-ignore
    mapRef.current.clearMap();
    const style = [
      {
        url: 'https://a.amap.com/jsapi_demos/static/images/mass0.png',
        // @ts-ignore
        anchor: new AMap.Pixel(0, 0),
        // @ts-ignore
        size: new AMap.Size(20, 20),
      },
      {
        url: 'https://a.amap.com/jsapi_demos/static/images/mass1.png',
        // @ts-ignore
        anchor: new AMap.Pixel(0, 0),
        // @ts-ignore
        size: new AMap.Size(20, 20),
      },
      {
        url: 'https://a.amap.com/jsapi_demos/static/images/mass2.png',
        // @ts-ignore
        anchor: new AMap.Pixel(3, 3),
        // @ts-ignore
        size: new AMap.Size(5, 5),
      },
    ];
    // @ts-ignore
    const mass = new AMap.MassMarks(
      list.map((item) => ({
        lnglat: [Number(item.lon), Number(item.lat)],
        name: item.name,
        style: item.status === '离线' ? 0 : 1,
      })),
      {
        opacity: 0.8,
        zIndex: 111,
        cursor: 'pointer',
        style,
      },
    );
    // @ts-ignore
    const marker = new AMap.Marker({ content: ' ', map: mapRef.current });

    // @ts-ignore
    mass.on('mouseover', function (e) {
      marker.setPosition(e.data.lnglat);
      marker.setLabel({ content: e.data.name });
    });

    // @ts-ignore
    mass.setMap(mapRef.current);
  };

  const initialMap = async (list?: { lat: string | number; lon: string | number; name: string; status: string }[]) => {
    try {
      if (AMapRef.current && mapRef.current) {
        showMass(list || []);
        return;
      }
      const AMap = await AMapLoader.load({
        key: mapKey,
        version: '2.0',
        plugins: ['AMap.MassMarks', 'AMap.Marker'],
      });
      AMapRef.current = AMap;
      // @ts-ignore
      mapRef.current = new AMap.Map(mapIdRef.current, {
        zoom: 4,
        center: [102.342785, 35.312316],
      });

      showMass(list || []);
    } catch (error) {
      console.error('AMap initialization error:', error);
    }
  };

  useEffect(() => {
    if (isInitialled) {
      initialMap(data);
    }
  }, [isInitialled, data]);

  return <div id={mapIdRef.current} style={{ width: '100%', height: '100%' }} />;
};

export default AMapView;
